import HonjoTabs from './HonjoTabs.vue'
import HonjoTabPane from './HonjoTabPane.vue'

export { HonjoTabs, HonjoTabPane }
